// Copyright (c) 2022 by Move Closer

import { CanHaveCustomClass, Module, ModuleContent, ModuleSourceOptions, ProductData, Related } from '../../contexts'

import { AvailableModuleDriver } from '../allowed'
import { HeadingFormData } from '../partials'

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
export type ProductsTeaserModule = Module<ProductsTeaserModuleContent, AvailableModuleDriver.ProductsTeaser>

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
export interface ProductsTeaserModuleData extends CanHaveCustomClass {
  /**
   * Determines products amount
   */
  count: number

  hasCart?: boolean

  /**
   * Determines products teaser heading
   */
  heading?: HeadingFormData

  /**
   * Determines products to render
   */
  products: ProductData[] | null

  /**
   * Determines products amount at carousel page
   */
  productsPerPage: number
}

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
export type ProductsTeaserModuleContent = ProductsTeaserModuleData & ModuleContent

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
export interface ProductsTeaserModuleContentInput extends Omit<ProductsTeaserModuleData, 'products'>, ModuleContent {
  sku: string | null
  filters: Related[] | null
  products: Related
}

export interface ProductsTeaserSourceOptions extends ModuleSourceOptions {
  mode: string
  sku?: boolean
}

export interface ProductsTeaserSourceConfigurationOptions {
  modeOptions: string[]
}

export enum ProductTeaserSourceMode {
  Brand = 'brand',
  Category = 'category',
  BrandAndCategory = 'brandAndCategory',
  Line = 'line',
  Filters = 'filters'
}
